import axios from "axios";

// Base URL .env se aata hai: REACT_APP_API_BASE_URL
const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export default API;
